export default __webpack_public_path__ + "static/media/domain-whois.8855555e.png";